export default __webpack_public_path__ + "static/media/chapter-01.png";